import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
    auth: {
        clientId: 'd05fd26d-82f0-4741-9fbd-8acbc65f18de',
        authority: "https://login.microsoftonline.com/a56222e7-2ad0-4357-81fc-8485f79f59ec",
        redirectUri: process.env.REACT_APP_REDIRECT
    },
    cache: {
        cacheLocation: "sessionStorage", // This configures where your cache will be stored
        storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
};

const pca = new PublicClientApplication(msalConfig);

export function getTokenMicro() {
    const accounts = pca.getAllAccounts();
    return new Promise((resolve, reject) => {
        pca
            .acquireTokenSilent({
                scopes: ["https://graph.microsoft.com/.default"],
                account: accounts[0],
            })
            .then((response) => {
                const accessToken = response.idToken;
                resolve(accessToken);
            })
            .catch((error) => {
                console.log(error)
            });
    });
}   
